import FingerprintJS from '@fingerprintjs/fingerprintjs';

const DEVICE_ID_KEY = 'deviceId';
let cachedDeviceId: string | null = null;

export async function getDeviceId(): Promise<string> {
  // 先查内存
  if (cachedDeviceId) return cachedDeviceId;
  // 再查 localStorage
  if (typeof window !== 'undefined') {
    const local = localStorage.getItem(DEVICE_ID_KEY);
    if (local) {
      cachedDeviceId = local;
      return local;
    }
  }
  // 生成
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  cachedDeviceId = `h5_${result.visitorId}`;
  // 存入 localStorage
  if (typeof window !== 'undefined') {
    localStorage.setItem(DEVICE_ID_KEY, cachedDeviceId);
  }
  return cachedDeviceId;
} 